import { render, staticRenderFns } from "./CsMultilineMultiselect.vue?vue&type=template&id=4b89812e&scoped=true&lang=pug&"
import script from "./CsMultilineMultiselect.vue?vue&type=script&lang=js&"
export * from "./CsMultilineMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./CsMultilineMultiselect.vue?vue&type=style&index=0&id=4b89812e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b89812e",
  null
  
)

export default component.exports